<div class="sidenav sidenav-offcanvas position-fixed" id="mySidenav" aria-label="Comment">
  <header class="sidenav__header d-flex justify-content-center align-items-center">

    <div class="d-flex w-100">
      <div class="d-flex align-items-center">
        <button type="button" class="btn btn-clear p-0 pt-1" aria-label="Back to comment" *ngIf="showBackBtn"
          (click)="getItemComments(selectNodeItemID,metaDataId);showHistoryBtn = true;showBackBtn = false;">
          <span class="material-icons-outlined font-4x" aria-hidden="true">arrow_back_ios</span>
        </button>
        <div class="notes p-0 m-0 tooltip bottom bottom-left position-relative" data-toggle="tooltip" [attr.data-tooltip]="title">
          <div class="notes-title text-left text-truncate mr-2">{{title}}</div>
        </div>
        <button type="button" class="btn btn-clear p-0 pt-2" aria-label="Show archived messages" *ngIf="showHistoryBtn"
          (click)="getarchiveList();showHistoryBtn = false;showBackBtn = true;">
          <em class="material-icons-outlined font-4x" aria-hidden="true">history</em>
        </button>
      </div>
    
      <div class="d-flex align-items-center ml-auto">
        <ng-container *ngIf="(!hasCommentLimit || (hasCommentLimit && noOfMyComments<commentLimit))">
          <button type="button" class="btn btn-cancel text-underline add-new font-bold" id="addnodeBtn" (click)="addNewNote()"
            *ngIf="editComments ? createCommentButton: false">Add
            New
          </button>
        </ng-container>
        <button type="button" class="btn btn-icon" id="cancleCommentBtn" (click)="cancleComment()" id="close-note"
          aria-label="Close">
          <em class="material-icons-outlined font-4x mt-2">close</em>
        </button>
      </div>
    </div>
  </header>


  <!--CREATE COMMENT STARTS-->
  <section class="card comment comment__create" *ngIf="addNewNotes">
    <div class="card-body comment__body">
      <figure class="figure">
        <figcaption class="figure-caption list-inline-item" aria-live="polite" aria-atomic="true">{{ userName }}
        </figcaption>
      </figure>

      <div class="form-group">
        <label for="writeNote" class="sr-only" id="descriptionLabel">Description</label>
        <textarea class="form-control" placeholder="Write a note..." id="writeNote" [(ngModel)]="commentNote"
          [formControl]="form.controls['description']" rows="2" (keyup)="checkValidation();"></textarea>
      </div>

      <div class="form-group" *ngIf="showAssignTo">
        <label for="assign-to" class="sr-only" id="assignLabel">Assign to</label>
        <select class="custom-select font-bold" id="assign-to" [(ngModel)]="selectedUser" (change)="selectAssignTo()">
          <option *ngFor="let user of userList" id="{{ user.full_name.split(' ').join('') }}"
            [disabled]="selectedUser?.user_id===user?.user_id" [ngValue]="user">
            {{ user.full_name }}</option>
        </select>
      </div>


    </div>
    <div class="w-100 text-right comment__footer">
      <button type="button" class="btn btn-cancel text-underline" id="canselCommentBtn" data-dismiss="modal"
        (click)="canselComment()">Cancel</button>
      <button type="button" class="btn btn-primary btn-sm" id="addCommentBtn" [disabled]="!(form.valid && valid)"
        (click)="addComment()">Add</button>
    </div>
  </section>


  <!--CREATE COMMENT ENDS-->
  <ng-container *ngIf="!archiveList">
    <div class="card comment sidenav__card" *ngFor="let data of tempCommentList;let rowIndex=index">
      <div class="card-header row">
        <div class="col-6 p-0">
          <figure class="figure mb-0">
            <figcaption class="figure-caption list-inline-item">{{ data.user_metadata?.trim().length ? data.user_metadata : data.created_by }}</figcaption>
            <p class="comment-time mb-0" aria-label="Comment post time">{{ formateDate(data) }}</p>
          </figure>

        </div>

        <div class="col-6 pr-0">
          <section class="row align-items-center text-right">
            <div class="col-6 ticket-status text-uppercase p-0">
              <ng-container *ngFor="let item of commentActions">
                <span *ngIf="data.status === item.value">{{item.name}}</span>
              </ng-container>

            </div>

            <div class="col-6" *ngIf="!preventEdit ? (checkCanChageStatus(data) && showChangeStatus) : false">
              <div class="more-option dropdown">
                <button class="btn btn-icon py-0 tooltip top top-right position-relative d-inline-block"
                  id="expandtochangeBtn" data-tooltip="Configure" [attr.aria-label]="'Expand to change status'"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <em class="material-icons-outlined font-4x" aria-hidden="true">more_horiz</em>
                </button>

                <div class="dropdown-menu">
                  <ng-container *ngFor="let item of commentActions">
                    <button class="btn btn-clear dropdown-item" id="{{item.name.split(' ').join('')}}Btn"
                      [disabled]="data?.status===item?.value"
                      (click)='changeStatus(item.value,data.thread_id,data.thread_comment_id,item.name)'>{{item.name}}</button>
                  </ng-container>
                </div>
              </div>
            </div>
          </section>

        </div>

      </div>
      <div class="card-body sidenav__card-body p-0">

        <div class="reply__section d-flex" aria-live="polite" aria-atomic="true">
          <div>
            <p class="username font-bold text-truncate mb-0 pr-4" aria-live="polite" aria-atomic="true"
            *ngIf="showAssignTo && data.assign_to?.length">Assigned
            to: {{ data.assign_to }}</p>
          <p *ngIf="checkCanEdit(data)" class="card-text text-break" [attr.contenteditable]="editComments"
            (blur)="editCommentTitle($event,data.thread_comment_id,data.thread_id,rowIndex,tempCommentList,'',data.item_comment)"
            aria-live="polite" aria-atomic="true">
            {{ data.item_comment }}
          </p>
          <p *ngIf="!checkCanEdit(data)" class="card-text text-break mr-2">
            {{ data.item_comment }}
          </p>
          </div>

          <ng-container *ngIf="!preventEdit ? (checkCanDelete(data) && showDelete) : false">
            <button (click)="deletComment(data.thread_comment_id, 'delete_notes')"
              class="btn btn-clear tooltip top top-right ml-auto position-relative" id="deletCommentBtn"
              data-tooltip="Delete comment" [attr.aria-label]="'Delete comment'">
              <em class="material-icons-outlined font-4x" aria-hidden="true">delete</em>
            </button>
          </ng-container>
        </div>

        <div class="text-right pr-2"
          *ngIf="!preventEdit ? (rowIndex !==commentIndex && data.comments.length === 1 && showReply) : false">
          <button *ngIf="checkCanReplyToOthers(data)" type="button" class="btn btn-cancel btn-reply text-underline px-0"
            id="addReplayBtn" (click)="addReplay(rowIndex,data)">Reply</button>
        </div>

        <div class="text-right pr-2"
          *ngIf="!preventEdit ? (rowIndex !==commentIndex && data.comments.length !== 1 &&  showReply) : false">
          <button *ngIf="checkCanReplyToOthers(data)" type="button" class="btn btn-cancel btn-reply text-underline px-0"
            id="replayBtn" (click)="addReplay(rowIndex,data)">Reply</button>
        </div>

        <div class="reply p-1" *ngIf="data.comments.length>0">
          <div class="reply__section pr-0" *ngFor="let comment of data.comments; let i = index" aria-live="polite"
            aria-atomic="true">
            <figure class="figure">
              <figcaption class="figure-caption list-inline-item">{{ comment.user_metadata?.length ? comment.user_metadata : comment.created_by }}</figcaption>
              <p class="comment-time mb-0" aria-label="Comment post time">{{ formateDate(comment) }}</p>
            </figure>
            <div class="d-flex">
            <p *ngIf="checkCanEdit(comment)" class="card-text text-break mr-2"
              [attr.contenteditable]="!preventEdit ? checkCanEdit(comment) : false"
              (blur)="editCommentTitle($event,comment.thread_comment_id,data.thread_id,i,data.comments,'reply',comment.comment)">
              {{ comment.comment }}
            </p>
            <p *ngIf="!checkCanEdit(comment)" class="card-text text-break mr-2">
              {{ comment.comment }}
            </p>
            <ng-container *ngIf="!preventEdit ? (checkCanDelete(comment) && showDelete) : false">
              <button type="button" class="btn btn-clear tooltip top top-right ml-auto position-relative" data-tooltip="Delete comment" [attr.aria-label]="'Delete comment'" *ngIf="showHistoryBtn" (click)="deletComment(comment.thread_comment_id, 'delete_reply')">
                <em class="material-icons-outlined font-4x float-right">
                  <span aria-hidden="true">delete</span>            
                </em>
              </button>
            </ng-container>
          </div>

          </div>
        </div>


      </div>


      <div id="comment-all" class="collapse">
      </div>

      <div class="card comment comment__create reply" *ngIf="commentBody && rowIndex ===commentIndex && showReply">
        <div class="card-body comment__body reply__section">
          <div class="form-group">
            <label for="writeReply" id="writeReplyLabel">Replying</label>
            <textarea class="form-control" placeholder="Add a reply" id="writeReply" rows="2"
              [(ngModel)]="comment"></textarea>
          </div>
          <div class="form-group" *ngIf="showAssignTo">
            <label for="assign-to" id="assignLabel" class="sr-only">Assign to</label>
            <select class="custom-select" id="assign-to" [(ngModel)]="selectedUser" (change)="selectAssignTo()">
              <option *ngFor="let user of userList" id="{{ user.full_name.split(' ').join('') }}Btn"
                [disabled]="selectedUser?.user_id===user?.user_id" [ngValue]="user">
                {{ user.full_name }}</option>
            </select>
          </div>

          <div class="float-right">
            <button type="button" class="btn btn-cancel text-underline" id="cancelCommentForCardBtn"
              data-dismiss="modal" (click)="cancelCommentForCard()">Cancel</button>
            <button type="button" class="btn btn-primary btn-sm" id="addCommentForCardBtn" [disabled]="!comment"
              (click)="addCommentForCard(rowIndex,data)">Add</button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <!--COMMENT OVERLAY ENDS-->

  <!--ARCHIVE LIST SATRT-->
  <ng-container *ngIf="archiveList">
    <div class="card comment sidenav__card" *ngFor="let data of tempCommentList;let rowIndex=index">
      <div class="card-header row">
        <div class="col-6 p-0">
          <span class="username font-bold text-truncate" aria-live="polite"
            aria-atomic="true">{{ data.assign_to }}</span>
        </div>

        <div class="col-6 pr-0" style="margin-top: 3px;">
          <section class="row align-items-center text-right">
            <div class="col-6 ticket-status text-uppercase p-0">
              <span>Closed</span>
            </div>

            <div class="col-6" *ngIf="!preventEdit ? (checkCanChageStatus(data) && showChangeStatus) : false">
              <div class="more-option dropdown">
                <button class="btn btn-icon py-0 tooltip top top-right position-relative d-inline-block"
                  id="expandstatusBtn" data-tooltip="Configure" [attr.aria-label]="'Expand to change status'"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <em class="material-icons-outlined font-4x" aria-hidden="true">more_horiz</em>
                </button>
                <div class="dropdown-menu">
                  <a href="javascript:void(0);" class="dropdown-item"
                    (click)='changeStatus(1,data.thread_id,data.thread_comment_id,"re-open");showHistoryBtn=true;showBackBtn=false;'>Re-Open</a>
                </div>
              </div>
            </div>
          </section>

        </div>

      </div>
      <div class="card-body sidenav__card-body p-0" aria-live="polite" aria-atomic="true">

        <div class="reply__section">
          <figure class="figure">
            <figcaption class="figure-caption list-inline-item">{{ data.user_metadata?.trim().length ? data.user_metadata : data.created_by }}</figcaption>
          </figure>
          <p class="card-text text-break">
            {{ data.item_comment }}
          </p>
          <p class="comment-time" aria-label="Comment post time">{{ formateDate(data) }}, today</p>
        </div>


        <div *ngFor="let comment of data.comments; let i = index">
          <div>
            <div class="reply">
              <div class="reply__section" style="margin-left: -10px">
                <figure class="figure">
                  <figcaption class="figure-caption list-inline-item">{{ comment.user_metadata?.length ? comment.user_metadata : comment.created_by }}</figcaption>
                </figure>
                <p class="card-text text-break">
                  {{ comment.comment }}
                </p>
                <p class="comment-time" aria-label="Comment post time">{{ formateDate(comment) }}, today</p>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div id="comment-all" class="collapse">
      </div>

      <div class="card comment comment__create reply" *ngIf="commentBody && rowIndex ==commentIndex && showReply">
        <div class="card-body comment__body reply__section" aria-live="polite" aria-atomic="true">
          <figure class="figure">
            <figcaption class="figure-caption list-inline-item">{{ userName }}</figcaption>
          </figure>

          <label for="writeReply" class="sr-only" id="replywriteBtn">Write a reply</label>
          <textarea class="form-control pl-0" placeholder="Write a reply..." id="writeReply" rows="1"
            [(ngModel)]="comment"></textarea>
          <div class="form-group" *ngIf="showAssignTo">
            <label for="assign-to" class="sr-only" id="assigntoBtn">Assign to</label>
            <select class="custom-select pl-0" id="assign-to" [(ngModel)]="selectedUser" (change)="selectAssignTo()">
              <option *ngFor="let user of userList" [ngValue]="user" id="{{ user.full_name.split(' ').join('') }}Btn"
                [disabled]="selectedUser?.user_id===user?.user_id">
                {{ user.full_name }}</option>
            </select>
          </div>
          <div class="float-right">
            <button type="button" class="btn btn-cancel text-underline" id="cnlCommentForCard" data-dismiss="modal"
              (click)="cancelCommentForCard()">Cancel</button>
            <button type="button" class="btn btn-primary btn-sm" id="commentForCardaddBtn" [disabled]="!comment"
              (click)="addCommentForCard(rowIndex,data)">Add</button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <!--ARCHIVE LIST END-->

</div>
